<template>
  <div class="image-multi">
    <ul class="image-multi__list">
      <li class="image-multi__item" :draggable="true" @dragstart="dragStart(index)" @dragenter="dragEnter(index)" @dragend.stop.prevent="dragEnd" @dragover.stop.prevent="dragOver" v-bind:key="index" v-for="(data, index) in dataList">
        <img :src="data" />
        <input type="hidden" :name="dataModel + '[' + dataColumn + '][' + index + ']'" :value="data" />
        <span class="image-multi__delete-button" @click="deleteLine(index)">✕</span>
      </li>
      <li class="image-multi__item-add">
        <label for="ImageGalleryFileInput"> 画像をドラッグ＆ドロップ<br />または<br />クリックして画像を選択 </label>
      </li>
    </ul>
    <input class="image-multi__input" id="ImageGalleryFileInput" type="file" multiple="multiple" @change="upload($event, file, index)" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
  data() {
    return {
      dataList: [],
      dataModel: null,
      dataColumn: null,
      draggingIndex: null,
    };
  },
  mounted() {
    const dataElement = this.$el.parentElement;

    this.dataList = JSON.parse(dataElement.dataset.value);

    if (this.dataList == null) {
      this.dataList = [];
    }

    this.dataModel = dataElement.dataset.model;
    this.dataColumn = dataElement.dataset.column;
  },
  methods: {
    upload: async function (event) {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      let formData = new FormData();
      Object.keys(event.target.files).map((index) => {
        formData.append('upfile[' + index + ']', event.target.files[index]);
      });

      axios.post('/file/upload_image_multi', formData, config).then((response) => {
        if (response.data.status == 'OK') {
          response.data.urlList.forEach((file) => {
            this.dataList.push(file);
          });
        } else if (response.data.message != null) {
          alert(response.data.message);
        } else {
          alert('ファイルアップロードに失敗しました');
        }
      });
    },
    deleteLine: async function (index) {
      this.dataList = this.dataList.filter((data, i) => {
        return i !== index;
      });
    },
    addLine: async function () {
      this.dataList.push({ code: '', text: '' });
    },
    dragStart: async function (index, e) {
      this.draggingIndex = index;
    },
    dragEnter: async function (index) {
      if (index === this.draggingIndex) return;

      const deleteElement = this.dataList.splice(this.draggingIndex, 1)[0];
      this.dataList.splice(index, 0, deleteElement);
      this.draggingIndex = index;
    },
    dragOver: async function (e) {},
    dragEnd: async function (e) {
      this.draggingIndex = null;
    },
  },
});
</script>
